import { reducer as modalReducer } from 'components/modal/ui-model';
import { reducer as layoutReducer } from 'components/layout/ui-model';

const reducer = {
  layout: layoutReducer,
  modal: modalReducer,
};

export default reducer;
